"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Label = function Label(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(StyledLabel, null, /*#__PURE__*/_react.default.createElement("p", null, children));
};

var StyledLabel = _styledComponents.default.div.withConfig({
  displayName: "StyledLabel"
})(["padding:0.5rem 1rem;min-width:7.5rem;background-color:#f0f1f3;border-radius:999px;p{font-family:", ";font-weight:bold;font-size:1.4rem;text-align:center;color:#8990a3;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

Label.propTypes = {
  /** Content of the label */
  children: _propTypes.node.isRequired
};
var _default = Label;
exports.default = _default;